import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

import { ButtonContainer, ModalBody, StyledModal } from './UploadInspectionDataModal.style';

interface IConfirmUploadModalProps {
  open: boolean;
  handleContinue: () => void;
  handleCancel: () => void;
}

export const ConfirmUploadModal: React.FunctionComponent<IConfirmUploadModalProps> = ({
  open,
  handleContinue,
  handleCancel,
}) => {
  const { t } = useTranslation();

  return (
    <StyledModal
      data-testid="upload-inspection-data-confirm-modal"
      title={t('inspection.confirmContinue', 'Confirm Continue')}
      open={open}
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
      destroyOnHidden
    >
      <ModalBody>
        <div>
          {t(
            'inspection.confirmContinueInvalidData',
            'Are you sure you want to continue with invalid or incomplete data? The created Inspections may be incomplete or fail entirely.'
          )}
        </div>
        <ButtonContainer>
          <Button onClick={handleCancel}>{t('common.cancel', 'Cancel')}</Button>
          <Button type="primary" onClick={handleContinue}>
            {t('common.continue', 'Continue')}
          </Button>
        </ButtonContainer>
      </ModalBody>
    </StyledModal>
  );
};
